"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var HttpMethods;
(function (HttpMethods) {
    HttpMethods["delete"] = "DELETE";
    HttpMethods["get"] = "GET";
    HttpMethods["patch"] = "PATCH";
    HttpMethods["put"] = "PUT";
})(HttpMethods = exports.HttpMethods || (exports.HttpMethods = {}));
var Auth0HttpMethods;
(function (Auth0HttpMethods) {
    Auth0HttpMethods["get"] = "GET";
    Auth0HttpMethods["patch"] = "PATCH";
    Auth0HttpMethods["post"] = "POST";
})(Auth0HttpMethods = exports.Auth0HttpMethods || (exports.Auth0HttpMethods = {}));
var CognitoHttpMethods;
(function (CognitoHttpMethods) {
    CognitoHttpMethods["post"] = "POST";
})(CognitoHttpMethods = exports.CognitoHttpMethods || (exports.CognitoHttpMethods = {}));
var CpaxHttpMethods;
(function (CpaxHttpMethods) {
    CpaxHttpMethods["post"] = "POST";
})(CpaxHttpMethods = exports.CpaxHttpMethods || (exports.CpaxHttpMethods = {}));
var GtwHttpMethods;
(function (GtwHttpMethods) {
    GtwHttpMethods["delete"] = "DELETE";
    GtwHttpMethods["get"] = "GET";
    GtwHttpMethods["post"] = "POST";
})(GtwHttpMethods = exports.GtwHttpMethods || (exports.GtwHttpMethods = {}));
var MsGraphHttpMethods;
(function (MsGraphHttpMethods) {
    MsGraphHttpMethods["delete"] = "DELETE";
    MsGraphHttpMethods["get"] = "GET";
    MsGraphHttpMethods["patch"] = "PATCH";
    MsGraphHttpMethods["post"] = "POST";
})(MsGraphHttpMethods = exports.MsGraphHttpMethods || (exports.MsGraphHttpMethods = {}));
var ScormHttpMethods;
(function (ScormHttpMethods) {
    ScormHttpMethods["get"] = "get";
    ScormHttpMethods["post"] = "post";
})(ScormHttpMethods = exports.ScormHttpMethods || (exports.ScormHttpMethods = {}));
var SlackHttpMethods;
(function (SlackHttpMethods) {
    SlackHttpMethods["post"] = "POST";
})(SlackHttpMethods = exports.SlackHttpMethods || (exports.SlackHttpMethods = {}));
//# sourceMappingURL=httpMethods.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@prolaera/types/dist/enums/httpMethods.js
// module id = 875
// module chunks = 0